import { ReactComponent as Property } from './property.svg';
import { ReactComponent as Mail } from './mail.svg';

const AuthIcon = { Property, Mail };
export default AuthIcon;
